<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { ConfigProvider, ToastProvider, ToastViewport, TooltipProvider } from 'reka-ui'

defineOptions({ inheritAttrs: false })

defineSlots<{ default(props: {}): unknown }>()

// Make TypeScript happier
declare const $t: (arg1: string, arg2?: Record<string, string>) => 'ltr' | 'rtl'
</script>

<template>
  <ConfigProvider :dir="$t('_meta.dir')">
    <ToastProvider :duration="6500">
      <TooltipProvider>
        <slot />

        <ToastViewport
          class="flopui-toast-container"
          data-toast-viewport
          :label="(hotkey) => $t('uikit.toast.viewport-label', { hotkey })"
        />
      </TooltipProvider>
    </ToastProvider>
  </ConfigProvider>
</template>

<style>
.flopui-toast-container {
  --viewport-padding: 1.75rem;
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: var(--viewport-padding);
  gap: 0.75rem;
  width: 25rem;
  max-width: 100vw;
  margin: 0;
  list-style: none;
  z-index: 2147483647;
  outline: none;
}

[dir='rtl'] .flopui-toast-container {
  right: unset;
  left: 0;
}
</style>
